import { render } from "./Emails.vue?vue&type=template&id=e1f8de50&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"

import "./Emails.vue?vue&type=style&index=0&id=e1f8de50&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f8de50"]])

export default __exports__